var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 39,
    r: 28,
    fill: "#F99B38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 39,
    r: 27.5,
    stroke: "#404044"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8554 28.0728C46.2093 28.4786 48 30.5302 48 32.9999C48 35.4013 46.3071 37.4073 44.0496 37.8896L43.8404 51.0162C43.8316 51.5684 43.3768 52.0089 42.8246 52.0001C42.2724 51.9913 41.8319 51.5365 41.8407 50.9843L42.0491 37.9096C39.7424 37.4655 38 35.4362 38 32.9999C38 30.6328 39.645 28.6498 41.8542 28.1318L41.8725 26.9841C41.8813 26.4319 42.3361 25.9913 42.8883 26.0001C43.4406 26.0089 43.8811 26.4637 43.8723 27.0159L43.8554 28.0728ZM34.1754 26.0002C34.7276 26.009 35.1681 26.4638 35.1593 27.0161L34.9509 40.0907C37.2576 40.5349 39 42.5642 39 45.0004C39 47.3676 37.355 49.3506 35.1458 49.8685L35.1275 51.0158C35.1187 51.568 34.6639 52.0085 34.1117 51.9997C33.5594 51.9909 33.1189 51.5361 33.1277 50.9839L33.1446 49.9275C30.7907 49.5217 29 47.4702 29 45.0004C29 42.599 30.6929 40.593 32.9504 40.1108L33.1596 26.9842C33.1684 26.432 33.6232 25.9914 34.1754 26.0002ZM46 32.9999C46 34.6568 44.6569 35.9999 43 35.9999C41.3431 35.9999 40 34.6568 40 32.9999C40 31.3431 41.3431 29.9999 43 29.9999C44.6569 29.9999 46 31.3431 46 32.9999ZM34 42.0004C32.3431 42.0004 31 43.3436 31 45.0004C31 46.6573 32.3431 48.0004 34 48.0004C35.6569 48.0004 37 46.6573 37 45.0004C37 43.3436 35.6569 42.0004 34 42.0004ZM52 42.0004C50.3431 42.0004 49 43.3436 49 45.0004C49 46.6573 50.3431 48.0004 52 48.0004C53.6569 48.0004 55 46.6573 55 45.0004C55 43.3436 53.6569 42.0004 52 42.0004ZM52.9509 40.0907L53.1593 27.0161C53.1681 26.4638 52.7276 26.009 52.1754 26.0002C51.6232 25.9914 51.1684 26.432 51.1596 26.9842L50.9504 40.1108C48.6929 40.593 47 42.599 47 45.0004C47 47.4702 48.7907 49.5217 51.1446 49.9275L51.1277 50.9839C51.1189 51.5361 51.5594 51.9909 52.1117 51.9997C52.6639 52.0085 53.1187 51.568 53.1275 51.0158L53.1458 49.8685C55.355 49.3506 57 47.3676 57 45.0004C57 42.5642 55.2576 40.5349 52.9509 40.0907Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 28,
    y: 26,
    width: 30,
    height: 28.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.354583 0 0 0 0 0.38985 0 0 0 0 0.575 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.07c2f4be655f3d305138470e86f8a8d9.svg";
export { ForwardRef as ReactComponent };